module.exports = __webpack_public_path__ + "img/bg.0664c441.jpg";